import { render, staticRenderFns } from "./TaskSettingsButtons.vue?vue&type=template&id=bcaed110&"
import script from "./TaskSettingsButtons.vue?vue&type=script&lang=js&"
export * from "./TaskSettingsButtons.vue?vue&type=script&lang=js&"
import style0 from "./TaskSettingsButtons.vue?vue&type=style&index=0&module=true&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./TaskSettingsButtons.vue?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./TaskSettingsButtons.vue?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("bcaed110")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcaed110')) {
      api.createRecord('bcaed110', component.options)
    } else {
      api.reload('bcaed110', component.options)
    }
    module.hot.accept("./TaskSettingsButtons.vue?vue&type=template&id=bcaed110&", function () {
      api.rerender('bcaed110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/sections/buttons/TaskSettingsButtons.vue"
export default component.exports